import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE } from "@/data/site";

/**
 * Structured Data for the law firm (Schema.org LegalService).
 * Helps Google display rich results (address, phones, hours, ratings) in search.
 */
const StructuredData = () => {
    const data = {
        "@context": "https://schema.org",
        "@type": "LegalService",
        name: SITE.fullName,
        alternateName: "ACD Advogados",
        url: "https://acd-advogados.net",
        logo: SITE.logoUrl,
        image: "/images/wp/2026/04/Ana-Cristina-Advocacia-Portugal.jpg",
        description:
            "Assessoria jurídica de excelência desde 1995 em Lisboa e Açores. Especialistas em Direito Penal, Civil, Trabalho, Comercial, Fiscal, Imigração e Nacionalidade.",
        priceRange: "€€",
        foundingDate: "1995",
        email: SITE.email,
        telephone: "+351217167664",
        address: [
            {
                "@type": "PostalAddress",
                streetAddress:
                    "Pátio das Fragatas, Av. Dom João II Nº 3 B, Loja 22",
                addressLocality: "Lisboa",
                postalCode: "1990-607",
                addressCountry: "PT",
            },
            {
                "@type": "PostalAddress",
                streetAddress: "Ed. Rotunda, Av. Natália Correia 2",
                addressLocality: "Ponta Delgada",
                postalCode: "9500-341",
                addressRegion: "Açores",
                addressCountry: "PT",
            },
        ],
        location: [
            {
                "@type": "Place",
                name: "Escritório em Lisboa",
                address: {
                    "@type": "PostalAddress",
                    streetAddress:
                        "Pátio das Fragatas, Av. Dom João II Nº 3 B, Loja 22",
                    addressLocality: "Lisboa",
                    postalCode: "1990-607",
                    addressCountry: "PT",
                },
                telephone: ["+351217167664", "+351217112928"],
            },
            {
                "@type": "Place",
                name: "Escritório em Ponta Delgada",
                address: {
                    "@type": "PostalAddress",
                    streetAddress: "Ed. Rotunda, Av. Natália Correia 2",
                    addressLocality: "Ponta Delgada",
                    postalCode: "9500-341",
                    addressRegion: "Açores",
                    addressCountry: "PT",
                },
                telephone: "+351296102222",
            },
        ],
        areaServed: [
            { "@type": "Country", name: "Portugal" },
            { "@type": "AdministrativeArea", name: "Açores" },
            { "@type": "AdministrativeArea", name: "Lisboa" },
        ],
        knowsLanguage: ["pt", "en", "fr", "es"],
        sameAs: [
            SITE.social.facebook,
            SITE.social.instagram,
            SITE.social.linkedin,
        ],
        founder: {
            "@type": "Person",
            name: "Ana Cristina Domingues",
            jobTitle: "Fundadora",
        },
        employee: [
            {
                "@type": "Person",
                name: "Dra. Ana Cristina Domingues",
                jobTitle: "Fundadora",
            },
            {
                "@type": "Person",
                name: "Dra. Maria José Domingues",
                jobTitle: "Responsável Adjunta - Lisboa",
            },
            {
                "@type": "Person",
                name: "Dr. Bartolomeu Domingues",
                jobTitle: "Responsável - Açores",
            },
        ],
        makesOffer: [
            { "@type": "Offer", name: "Direito Penal & Contraordenacional" },
            { "@type": "Offer", name: "Direito Civil" },
            { "@type": "Offer", name: "Direito do Trabalho" },
            { "@type": "Offer", name: "Direito Administrativo" },
            { "@type": "Offer", name: "Direito Fiscal e Tributário" },
            { "@type": "Offer", name: "Direito Comercial e Financeiro" },
            { "@type": "Offer", name: "Imigração e Nacionalidade" },
            { "@type": "Offer", name: "Atos Notariais" },
        ],
        aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "5.0",
            reviewCount: "4",
            bestRating: "5",
        },
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(data)}
            </script>
        </Helmet>
    );
};

export default StructuredData;
